import axios from 'axios';
import { tokenConfig, returnError } from './helperFunc';

const SET_GLOBAL_LOADING = 'SET_GLOBAL_LOADING';
const CLEAR_GLOBAL_ERROR = 'CLEAR_GLOBAL_ERROR';

const SET_MAINTENANCE_LOADING = 'SET_MAINTENANCE_LOADING';
const CLEAR_MAINTENANCE_ERROR = 'CLEAR_MAINTENANCE_ERROR';

const SET_OFFLINE_LOADING = 'SET_OFFLINE_LOADING';
const CLEAR_OFFLINE_ERROR = 'CLEAR_OFFLINE_ERROR';

const GET_DEVICES_SUCCESS = 'GET_DEVICES_SUCCESS';
const GET_DEVICES_FAIL = 'GET_DEVICES_FAIL';

const UPDATE_OUTLET_SUCCESS = 'UPDATE_OUTLET_SUCCESS';
const UPDATE_OUTLET_FAIL = 'UPDATE_OUTLET_FAIL';

const UPDATE_DEVICE_SUCCESS = 'UPDATE_DEVICE_SUCCESS';
const UPDATE_DEVICE_FAIL = 'UPDATE_DEVICE_FAIL';

const GET_GLOBAL_OUTLETS_SUCCESS = 'GET_GLOBAL_OUTLETS_SUCCESS';
const GET_GLOBAL_OUTLETS_FAIL = 'GET_GLOBAL_OUTLETS_FAIL';

const UPDATE_FIRMWARE_SUCCESS = 'UPDATE_FIRMWARE_SUCCESS';
const UPDATE_FIRMWARE_FAIL = 'UPDATE_FIRMWARE_FAIL';

const UPDATE_FIRMWARE_BY_OUTLET_SUCCESS = 'UPDATE_FIRMWARE_BY_OUTLET_SUCCESS';
const UPDATE_FIRMWARE_BY_OUTLET_FAIL = 'UPDATE_FIRMWARE_BY_OUTLET_FAIL';

const GET_MAINTENANCE_SUCCESS = 'GET_MAINTENANCE_SUCCESS';
const GET_MAINTENANCE_FAIL = 'GET_MAINTENANCE_FAIL';

const GET_OFFLINE_SUCCESS = 'GET_OFFLINE_SUCCESS';
const GET_OFFLINE_FAIL = 'GET_OFFLINE_FAIL';

const GET_ALPHA_FIRMWARE_LATEST_PERCENT_SUCCESS =
  'GET_ALPHA_FIRMWARE_LATEST_PERCENT_SUCCESS';
const GET_ALPHA_FIRMWARE_LATEST_PERCENT_FAIL =
  'GET_ALPHA_FIRMWARE_LATEST_PERCENT_FAIL';

const GLOBAL_CALIBRATE_SUCCESS = 'GLOBAL_CALIBRATE_SUCCESS';
const GLOBAL_CALIBRATE_FAIL = 'GLOBAL_CALIBRATE_FAIL';

const RESET_CALIBRATE_SUCCESS = 'RESET_CALIBRATE_SUCCESS';
const RESET_CALIBRATE_FAIL = 'RESET_CALIBRATE_FAIL';

const UPDATE_CALIBRATED_BY_OUTLET_SUCCESS = 'UPDATE_CALIBRATED_BY_OUTLET_SUCCESS';
const UPDATE_CALIBRATED_BY_OUTLET_FAIL = 'UPDATE_CALIBRATED_BY_OUTLET_FAIL';

const UPDATE_RESET_CALIBRATED_BY_OUTLET_SUCCESS = 'UPDATE_RESET_CALIBRATED_BY_OUTLET_SUCCESS';
const UPDATE_RESET_CALIBRATED_BY_OUTLET_FAIL = 'UPDATE_RESET_CALIBRATED_BY_OUTLET_FAIL';

const apiUrl = process.env.REACT_APP_API_URL;

export const getOutletsGlobalConfig = (admin) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_GLOBAL_ERROR });
    dispatch({ type: SET_GLOBAL_LOADING });

    const config = tokenConfig(admin);
    const { data } = await axios.get(`${apiUrl}/api/global/outlets`, config);
    // console.log('data', data.data)
    dispatch({ type: GET_GLOBAL_OUTLETS_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({ type: GET_GLOBAL_OUTLETS_FAIL, payload: returnError(error) });
  }
};

export const updateOutletGlobalConfig = (resBody) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_GLOBAL_ERROR });
    dispatch({ type: SET_GLOBAL_LOADING });

    const config = tokenConfig();
    const { data } = await axios.post(
      `${apiUrl}/api/global/update/configuration`,
      resBody,
      config
    );
    // console.log('data', data.data)
    dispatch({ type: UPDATE_OUTLET_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({ type: UPDATE_OUTLET_FAIL, payload: returnError(error) });
  }
};

export const updateGlobalFirmwareUpdate = (resBody) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_GLOBAL_ERROR });
    dispatch({ type: SET_GLOBAL_LOADING });

    const config = tokenConfig();
    const { data } = await axios.post(
      `${apiUrl}/api/global/update/latestFirmwareUpdated`,
      resBody,
      config
    );
    // console.log('data', data.data)
    dispatch({ type: UPDATE_FIRMWARE_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({ type: UPDATE_FIRMWARE_FAIL, payload: returnError(error) });
  }
};

export const updateGlobalCalibration = (resBody) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_GLOBAL_ERROR });
    dispatch({ type: SET_GLOBAL_LOADING });

    const config = tokenConfig();
    const { data } = await axios.post(
      `${apiUrl}/api/global/update/globalCalibration`,
      resBody,
      config
    );
    // console.log('data', data.data)
    dispatch({ type: GLOBAL_CALIBRATE_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({ type: GLOBAL_CALIBRATE_FAIL, payload: returnError(error) });
  }
};

export const updateGlobalResetCalibration = (resBody) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_GLOBAL_ERROR });
    dispatch({ type: SET_GLOBAL_LOADING });

    const config = tokenConfig();
    const { data } = await axios.post(
      `${apiUrl}/api/global/update/globalResetCalibration`,
      resBody,
      config
    );
    // console.log('data', data.data)
    dispatch({ type: RESET_CALIBRATE_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({ type: RESET_CALIBRATE_FAIL, payload: returnError(error) });
  }
};

export const updateGlobalFirmwareByOutlet = (resBody) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_GLOBAL_ERROR });
    dispatch({ type: SET_GLOBAL_LOADING });

    const config = tokenConfig();
    const { data } = await axios.post(
      `${apiUrl}/api/global/outlet/update/latestFirmware`,
      resBody,
      config
    );
    // console.log('data', data.data)
    dispatch({ type: UPDATE_FIRMWARE_BY_OUTLET_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({
      type: UPDATE_FIRMWARE_BY_OUTLET_FAIL,
      payload: returnError(error),
    });
  }
};

export const updateGlobalCalibratedByOutlet = (resBody) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_GLOBAL_ERROR });
    dispatch({ type: SET_GLOBAL_LOADING });

    const config = tokenConfig();
    const { data } = await axios.post(
      `${apiUrl}/api/global/outlet/update/latestCalibrated`,
      resBody,
      config
    );
    // console.log('data', data.data)
    dispatch({ type: UPDATE_CALIBRATED_BY_OUTLET_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({
      type: UPDATE_CALIBRATED_BY_OUTLET_FAIL,
      payload: returnError(error),
    });
  }
};

export const updateResetGlobalCalibratedByOutlet = (resBody) => async (dispatch) => {
  try {
    dispatch({ type: CLEAR_GLOBAL_ERROR });
    dispatch({ type: SET_GLOBAL_LOADING });

    const config = tokenConfig();
    const { data } = await axios.post(
      `${apiUrl}/api/global/outlet/update/latestResetCalibrated`,
      resBody,
      config
    );
    // console.log('data', data.data)
    dispatch({ type: UPDATE_RESET_CALIBRATED_BY_OUTLET_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({
      type: UPDATE_RESET_CALIBRATED_BY_OUTLET_FAIL,
      payload: returnError(error),
    });
  }
};

export const getAlphaFirmwareLatestPercent =
  (version, deviceModel) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_GLOBAL_ERROR });
      dispatch({ type: SET_GLOBAL_LOADING });

      const config = tokenConfig();
      const { data } = await axios.get(
        `${apiUrl}/api/global/alphaFirmwareLatestPercent?version=${version}&deviceModel=${deviceModel}`,
        config
      );
      // console.log('data', data.data)
      dispatch({
        type: GET_ALPHA_FIRMWARE_LATEST_PERCENT_SUCCESS,
        payload: data.data,
      });
    } catch (error) {
      dispatch({
        type: GET_ALPHA_FIRMWARE_LATEST_PERCENT_FAIL,
        payload: returnError(error),
      });
    }
  };

  export const getMaintenanceData = (outletIds, admin) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_MAINTENANCE_ERROR });
      dispatch({ type: SET_MAINTENANCE_LOADING });
  
      const config = tokenConfig();
  
      const { data } = await axios.post(
        `${apiUrl}/api/global/maintenance/log`,
        { outletIds }, 
        config
      );
  
      dispatch({ type: GET_MAINTENANCE_SUCCESS, payload: data.data });
    } catch (error) {
      dispatch({ type: GET_MAINTENANCE_FAIL, payload: returnError(error) });
    }
  };

  export const getOfflineData = (params, admin) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_OFFLINE_ERROR });
      dispatch({ type: SET_OFFLINE_LOADING });
      
      const config = tokenConfig();
  
      const { data } = await axios.post(
        `${apiUrl}/api/global/offline/log`,
        params, // Pass the params object containing outletIds, startDate, and endDate
        config
      );
  
      dispatch({ type: GET_OFFLINE_SUCCESS, payload: data.data });
    } catch (error) {
      dispatch({ type: GET_OFFLINE_FAIL, payload: returnError(error) });
    }
  };
  
  

const initialState = {
  error: null,
  loading: false,
  outlets: [],
  maintenance: [],
  offline: []
};

// laundro
// washupp
// cleanpro
// washstudio
// cuci

export const globalConfigReducer = function (state = initialState, action) {
  switch (action.type) {
    // this is for fetching loading time setter
    case SET_GLOBAL_LOADING:
      return {
        ...state,
        loading: true,
      };

    case SET_MAINTENANCE_LOADING:
      return {
        ...state,
        loading: true,
      };  

    case SET_OFFLINE_LOADING:
      return {
        ...state,
        loading: true,
      };  
  
    case CLEAR_GLOBAL_ERROR:
      return {
        ...state,
        error: null,
      };

    case CLEAR_MAINTENANCE_ERROR:
      return {
        ...state,
        error: null,
      };

    case CLEAR_OFFLINE_ERROR:
      return {
        ...state,
        error: null,
      };

    case GET_GLOBAL_OUTLETS_SUCCESS:
      return {
        ...state,
        outlets: action.payload,
        loading: false,
        error: false,
      };

    case GET_MAINTENANCE_SUCCESS:
      return {
        ...state,
        maintenance: action.payload,
        loading: false,
        error: false,
      };  

    case GET_OFFLINE_SUCCESS:
      return {
        ...state,
        offline: action.payload,
        loading: false,
        error: false,
      };  

    case GET_ALPHA_FIRMWARE_LATEST_PERCENT_SUCCESS:
      return {
        ...state,
        outlets: state.outlets.length
          ? state.outlets.map((outlet) => {
              const curOutlet = action.payload.find(
                (each) => each.id === outlet.id
              );

              return {
                ...outlet,
                ...curOutlet,
              };
            })
          : state.outlets,
        loading: false,
        error: false,
      };

    // user login and registration success
    case GET_DEVICES_SUCCESS:
      return {
        ...state,
        devices: action.payload,
        loading: false,
        error: false,
      };

    case UPDATE_DEVICE_SUCCESS:
    case UPDATE_FIRMWARE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };

    case GLOBAL_CALIBRATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };

    case RESET_CALIBRATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };

    case UPDATE_OUTLET_SUCCESS:
      // console.log('action.payload', action.payload);
      return {
        ...state,
        outlets: state.outlets.length
          ? state.outlets.map((each) => {
              const outlet = action.payload.find((e) => e.id === each.id);
              if (outlet) {
                return {
                  ...each,
                  configurable: outlet.configurable,
                };
              } else {
                return each;
              }
            })
          : state.outlets,
        loading: false,
        error: false,
      };

    case UPDATE_FIRMWARE_BY_OUTLET_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };

    case UPDATE_CALIBRATED_BY_OUTLET_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };

    case UPDATE_RESET_CALIBRATED_BY_OUTLET_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    // user auth error and logout
    case GET_DEVICES_FAIL:
    case UPDATE_OUTLET_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case UPDATE_DEVICE_FAIL:
    case GET_GLOBAL_OUTLETS_FAIL:
    case GET_OFFLINE_FAIL:
    case UPDATE_FIRMWARE_BY_OUTLET_FAIL:
    case GET_ALPHA_FIRMWARE_LATEST_PERCENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
